import "./format.css";
import { FaUser, FaShoppingCart, FaChartLine, FaCampground, FaWallet, FaChartBar, FaFreeCodeCamp } from "react-icons/fa";
import { CgSpinner } from "react-icons/cg";
import { MdOutlineRequestPage } from "react-icons/md";
import { Link } from "react-router-dom";
import { getAdminDashboard } from "services/dashboard";
import { useEffect , useState} from "react";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

export default function Management() {
  const [manageValue, setManageValue] = useState({
    allMembers: 0,
    activeTourCounts: 0,
    allRemainingCapacity:0,
    customersInventory: 0,
    thisMonthMembers:0,
    uncompletedReserves:0,
    withdrawCount: 0,
  });



  useEffect(() => {
    const getInfo = async () => {
      let data = await getAdminDashboard().then((res) => res);
      setManageValue((prev) => {
            return { ...prev,
               allMembers: data.allMembers,
               activeTourCounts: data.activeTourCounts, 
               allRemainingCapacity: data.allRemainingCapacity,
               customersInventory: data.customersInventory,
               uncompletedReserves: data.uncompletedReserves,
               thisMonthMembers: data.thisMonthMembers,
               withdrawCount: data.withdrawCount,};
          });
    };
    getInfo()
  }, []);

  return (
    <div className="d-flex flex-nowrap ">
      <div className="col py-3 manager1">
        <div className="d-flex flex-wrap justify-content-center px-2">
          <div className="d-flex justify-content-between flex-column flex-md-row w-100">
            <div className="amar m-2 text-center bg-white ">
              <Link to="/admin-panel/user-management" className="d-flex border rounded-3">
                <div className="rounded p-5" style={{ backgroundColor: " rgb(228, 58, 58)" }}>
                  <FaUser className=" text-white fs-50" />
                </div>
                <div className="p-4 mx-auto">
                  <h5 className="digits text-black-50">{addCommas(manageValue.allMembers)}</h5>
                  <h6 className="text-black-50">تعداد کل کاربران</h6>
                </div>
              </Link>
            </div>
            <div className="amar m-2 text-center bg-white">
              <Link to="/admin-panel/user-management" className="d-flex border rounded-3">
                <div className="rounded  p-5" style={{ backgroundColor: "rgb(146, 82, 120)" }}>
                  <FaChartLine className=" text-white fs-50 " />
                </div>
                <div className="p-4 mx-auto">
                  <h5 className="digits text-black-50">{addCommas(manageValue.thisMonthMembers)}</h5>
                  <h6 className="text-black-50">تعداد کاربران این ماه</h6>
                </div>
              </Link>
            </div>
          </div>
          <div className="d-flex justify-content-between flex-column flex-md-row w-100">
            <div className="amar m-2 text-center bg-white">
              <Link to="" className="d-flex border rounded-3">
                <div className="rounded p-5 py-md-5 px-md-4" style={{ backgroundColor: "rgb(8, 143, 103)" }}>
                  <FaFreeCodeCamp className=" text-white fs-50" />
                </div>
                <div className="p-4 mx-auto">
                  <h5>
                  {addCommas(manageValue.activeTourCounts)}
                    <br />
                  </h5>
                  <h6 className="text-black-50">تعداد تورهای فعال</h6>
                </div>
              </Link>
            </div>
            <div className="amar m-2 text-center bg-white">
              <Link to="" className="d-flex border border rounded-3">
                <div className="rounded p-5 py-md-5 px-md-4" style={{ backgroundColor: "rgb(170, 43, 85)" }}>
                  <FaShoppingCart className=" text-white fs-50 " />
                </div>
                <div className="p-4 mx-auto">
                  <h5 className="digits text-black-50">{addCommas(manageValue.allRemainingCapacity)}</h5>
                  <h6 className="text-black-50">مجموع ظرفیت باقی مانده</h6>
                </div>
              </Link>
            </div>
            <div className="amar m-2 text-center bg-white">
              <Link to="" className="d-flex border border rounded-3">
                <div className="rounded p-5 py-md-5 px-md-4" style={{ backgroundColor: "#99aa2b" }}>
                  <CgSpinner className=" text-white fs-50 " />
                </div>
                <div className="p-4 mx-auto">
                  <h5 className="digits text-black-50">{addCommas(manageValue.uncompletedReserves)}</h5>
                  <h6 className="text-black-50">تعداد رزروهای کامل نشده</h6>
                </div>
              </Link>
            </div>
          </div>
          <div className="d-flex justify-content-between flex-column flex-md-row w-100">
            <div className="amar m-2 text-center bg-white ">
              <Link to="/admin-panel/financial-department" className="d-flex border rounded-3">
                <div className="rounded p-5" style={{ backgroundColor: "#2baa31" }}>
                  <MdOutlineRequestPage className=" text-white fs-50" />
                </div>
                <div className="p-4 mx-auto">
                  <h5>
                  {addCommas(manageValue.withdrawCount)}
                    <br />
                  </h5>
                  <h6 className="text-black-50">تعداد درخواست های برداشت</h6>
                </div>
              </Link>
            </div>
            <div className="amar m-2 text-center bg-white">
              <Link to="/admin-panel/financial-department" className="d-flex border border rounded-3">
                <div className="rounded p-5" style={{ backgroundColor: "#2b84aa" }}>
                  <FaWallet className=" text-white fs-50 " />
                </div>
                <div className="p-4 mx-auto">
                  <h5 className="digits text-black-50">{addCommas(manageValue.customersInventory)}</h5>
                  <h6 className="text-black-50">مجموع موجودی کاربران</h6>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
